export default __webpack_public_path__ + "assets/images/7e1a2aa51f9b0d402f8c337e943866d9.png";